//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import('./indexAppl');
const edit = () => import('./edit.vue');
const recommend=()=>import('./recommend.vue');


export default {
  routes: [
    {
      path: '/innovation/v2024/indexAppl',
      name: 'innovation_v2024_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/innovation/v2024/indexAdmin',
      name: 'innovation_v2024_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/innovation/v2024/edit',
      name: 'innovation_v2024_edit',
      component: edit,
      meta: {public: true}
    },
    {
      path: '/innovation/v2024/recommend',
      name: 'innovation_v2024_recommend',
      component: recommend,
      meta: {public: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/innovation/v2024/router.js